import { HEALTHCHECK_NAMES } from 'domain/shared/newProject';
import EngineeringSections from './sections/EngineeringSections';
import EngineeringHealthchecks from './EngineeringHealthchecks';
import BaseControl from '../BaseControl';
import { resolveControlsZone } from '../utils';
import { ControlData } from '../types';
import { PROJECT_MEMBERSHIP_ROLES_KEY } from 'domain/shared/core/constants';

type EngineeringControlProps = {
  data: ControlData;
  showSections?: boolean;
  refetchControlsData?: () => Promise<unknown>;
};

export const engineeringHealthcheckNames = [
  HEALTHCHECK_NAMES.PPC,
  HEALTHCHECK_NAMES.ENGINEERING_BUGS,
  HEALTHCHECK_NAMES.ENGINEERING_RISKS,
  HEALTHCHECK_NAMES.ENGINEERING_INCIDENTS,
  HEALTHCHECK_NAMES.ENGINEERING_SETUP,
  HEALTHCHECK_NAMES.ENGINEERING_LINK,
] as const;

const EngineeringControl = ({
  data,
  showSections = true,
  refetchControlsData = () => Promise.resolve(),
}: EngineeringControlProps) => {
  const zone = resolveControlsZone({
    healthChecks: data?.health?.healthChecks,
    healthcheckNames: [...engineeringHealthcheckNames],
  });
  const teamLead = data?.team?.members?.find(member => member.role === PROJECT_MEMBERSHIP_ROLES_KEY.TEAM_LEAD);

  return (
    <BaseControl
      title="Engineering"
      zone={zone}
      controlResponsible={teamLead?.employeeAlias}
      healthchecks={<EngineeringHealthchecks data={data} />}
      sections={showSections ? <EngineeringSections data={data} refetchControlsData={refetchControlsData} /> : null}
    />
  );
};
export default EngineeringControl;
